import CareTeamList from './careTeamList';
// import CareTeamList from './external/externalCareTeamList';

export default CareTeamList;
